export const INDENTIFICATION_TYPES = {
  DRIVERS_LICENSE: '1',
  PASSPORT_INSURANCE: '2',
  RESIDENCE_CARD: '3',
  MY_NUMBER_CARD: '4',
};
